import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { Check, ChevronsUpDown } from "lucide-react";

export function ArtikelCombo({ artikelen, value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" data-testid={testid} className="w-full justify-between font-normal">
          <span className="truncate">{value || "— geen artikel —"}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput data-testid="sales-art-search" placeholder="Zoek artikelnr of naam" />
          <CommandList>
            <CommandEmpty>Geen artikel gevonden.</CommandEmpty>
            <CommandGroup>
              <CommandItem value="— geen artikel —" onSelect={() => { onChange(""); setOpen(false); }}>
                <Check className={`mr-2 h-4 w-4 ${!value ? "opacity-100" : "opacity-0"}`} />{"— geen artikel —"}
              </CommandItem>
              {artikelen.map((a) => {
                const label = a.sample ? `SAMPLE ${a.samplecode || a.artikelnummer} - ${a.naam} (nieuw product)` : `${a.artikelnummer} - ${a.naam}`;
                return (
                  <CommandItem key={a.artikelnummer + a.naam} value={label} onSelect={() => { onChange(label); setOpen(false); }}>
                    <Check className={`mr-2 h-4 w-4 ${value === label ? "opacity-100" : "opacity-0"}`} />{label}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default ArtikelCombo;
